import React from "react";
import axios from 'axios';
import { Link } from "react-router-dom";
import Datatables from "../../components/Datatables/Table";
import TableCell from "../../components/Datatables/TableCell";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faEye,faTrash } from "@fortawesome/free-solid-svg-icons";
import ExpensesModal from "../../components/Modal";
import DeleteConfirmationModal from "../../components/Delete";
const user = JSON.parse(localStorage.getItem("user"));
function GroupTable({ loading, dataHeader, data, handleDelete ,setReload,reload }) {
  const [modal, setModal] = React.useState(false);
  const [deleteModal,setDeleteModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  // const [deleteGroup,setDeleteGroup] = React.useState(false);

  const addExpenseOnClick = (row) => {
    setSelectedRow(row);
    setModal(true);
  };
  const handleDeleteGroupClick = (row) =>{
    setSelectedRow(row);
    setDeleteModal(true);
  }

  const closeModal = () => {
    setDeleteModal(false)
    setModal(false);
    setSelectedRow(null);
  };

  const handleDeleteGroupItem = async(groupId) => {
    try{
      const url = `https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/groups/delete/${groupId}`
      const response = await axios.delete(url,{
        headers: {
          Authorization: `Bearer ${user.idToken}`,
        },
      })
      console.log('Deleted Successfully',response)
      setReload(!reload);
      setDeleteModal(false);
      setSelectedRow(null)
      alert('Group Deleted Successfully')
    }
    catch(e){
      console.log('error',e)
    }
  
  }
  return (
    <Datatables loading={loading} dataHeader={dataHeader}>
      {data?.map((row, index) => (
        <tr
          key={index}
          className="bg-white border md:border-b block md:table-row rounded-md shadow-md md:rounded-none md:shadow-none mb-5"
        >
          <TableCell dataLabel="G-Name" showLabel={true}>
            <span className="font-medium text-sm text-gray-900">
              {row.name}
            </span>
          </TableCell>
          <TableCell dataLabel="Owner" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">{row.owner}</p>
          </TableCell>
          <TableCell dataLabel="Total Expense" showLabel={true}>
            <p className="font-normal text-sm text-gray-500">{row.amount}</p>
          </TableCell>
          <TableCell dataLabel="You Owe" showLabel={true}>
            {row.expense < 0 ? (
              <span className="rounded-full py-1 px-3 text-xs font-semibold bg-red-200 text-red-900">
                {row.expense}
              </span>
            ) : (
              <span className="rounded-full py-1 px-3 text-xs font-semibold bg-emerald-200 text-green-900">
                {row.expense}
              </span>
            )}
          </TableCell>
          <TableCell>
            <div className="text-sky-700 inline-flex py-2 px-2 rounded text-sm">
              <button
                className="clickme"
                onClick={() => addExpenseOnClick(row)}
              >
                <FontAwesomeIcon icon={faPencil} />
              </button>
            </div>
            <Link
              key={`link-${row.id}`}
              to={{
                pathname: `/group/${row.groupid}`,
                state: row ,
              }}
              className="text-sky-700 inline-flex py-2 px-2 rounded text-sm"
            >
              <FontAwesomeIcon icon={faEye} />
            </Link>
            <div className="text-sky-700 inline-flex py-2 px-2 rounded text-sm">
              <button
                className="clickme"
                onClick={() => handleDeleteGroupClick(row)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>
          </TableCell>
        </tr>
      ))}
      {modal && (
        <ExpensesModal
          isOpen={modal}
          setModal={setModal}
          onClose={closeModal}
          groupData={selectedRow}
        />
      )}
      {deleteModal && (
        <DeleteConfirmationModal
          handleDeleteItem = {handleDeleteGroupItem}
          groupId = {selectedRow.groupid}
          onClose={closeModal}
        />
      )}
    </Datatables>
  );
}

export default GroupTable;
